var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 128,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6DEE1",
    d: "M24.14 51.164v-.039c0-9.295 7.536-16.829 16.83-16.829 3.861 0 7.42 1.302 10.258 3.49 2.673-9.767 11.61-16.943 22.225-16.943h1.53c11.518 0 21.06 8.45 22.77 19.489 11.191 1.196 19.906 10.666 19.906 22.175 0 12.318-9.985 22.302-22.302 22.302H50.481v-.069H25.828C16.533 84.74 9 77.205 9 67.911c0-8.725 6.64-15.9 15.143-16.747z",
    opacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#error_svg__a)",
    d: "M109.044 103.544c8.817-8.818 8.817-23.114 0-31.93-8.818-8.818-23.114-8.818-31.93 0-8.818 8.816-8.818 23.112 0 31.93 8.816 8.817 23.112 8.817 31.93 0",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9789FF",
    d: "m105.925 84.875-3.353-5.75A4.3 4.3 0 0 0 98.852 77h-6.705c-1.534 0-2.95.81-3.719 2.125l-3.353 5.75a4.22 4.22 0 0 0 0 4.25l3.353 5.75A4.3 4.3 0 0 0 92.148 97h6.705c1.534 0 2.951-.81 3.719-2.125l3.353-5.75a4.21 4.21 0 0 0 0-4.25M95.501 89.91c-1.624 0-2.94-1.302-2.94-2.91 0-1.607 1.316-2.909 2.94-2.909s2.938 1.302 2.938 2.91c0 1.607-1.315 2.909-2.938 2.909",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6DEE1",
    d: "m103.925 84.875-3.353-5.75A4.3 4.3 0 0 0 96.852 77h-6.705c-1.534 0-2.951.81-3.719 2.125l-3.353 5.75a4.22 4.22 0 0 0 0 4.25l3.353 5.75A4.3 4.3 0 0 0 90.148 97h6.705c1.534 0 2.95-.81 3.719-2.125l3.353-5.75a4.21 4.21 0 0 0 0-4.25M93.501 89.91c-1.624 0-2.94-1.302-2.94-2.91 0-1.607 1.316-2.909 2.94-2.909s2.938 1.302 2.938 2.91c0 1.607-1.315 2.909-2.938 2.909"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0E1214",
    fillRule: "evenodd",
    d: "M48.757 36.203a16.752 16.752 0 0 0-7.787-1.907c-2.95 0-5.721.758-8.132 2.09L55.4 58.946a11.78 11.78 0 0 0 2.988 11.604c3.172 3.172 7.7 4.155 11.719 2.957h-.003l-4.265-4.264a4.845 4.845 0 0 1 0-6.85l1.061-1.058a4.844 4.844 0 0 1 6.851 0l4.26 4.26c1.192-4.017.21-8.55-2.952-11.71-3.143-3.143-7.618-4.137-11.608-2.987z",
    clipRule: "evenodd",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#99ACB5",
    d: "m66.819 72.847-4.1-4.08a4.62 4.62 0 0 1 0-6.552l1.02-1.014a4.67 4.67 0 0 1 6.585 0l4.093 4.075c1.147-3.842.202-8.18-2.837-11.203-3.02-3.007-7.321-3.957-11.156-2.858l-35.779-35.62a5.49 5.49 0 0 0-7.739 0 5.43 5.43 0 0 0 0 7.704l35.781 35.616a11.23 11.23 0 0 0 2.872 11.103c3.048 3.035 7.4 3.976 11.262 2.829zm-48.013-55.36a2.696 2.696 0 0 1 3.8 0 2.67 2.67 0 0 1 0 3.783 2.696 2.696 0 0 1-3.8 0 2.67 2.67 0 0 1 0-3.783"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F6FB",
    d: "M25.255 23.905a2.696 2.696 0 0 1 3.8 0l25.318 25.2a2.67 2.67 0 0 1 0 3.782 2.696 2.696 0 0 1-3.801 0L25.252 27.69a2.67 2.67 0 0 1 0-3.783z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#18FFFF",
    d: "M73.194 101.88c-.57-.211-.57-1.016 0-1.226l1.878-.696a.65.65 0 0 0 .386-.386l.696-1.879a.654.654 0 0 1 1.226 0l.695 1.88c.066.178.207.32.386.385l1.879.696c.569.21.569 1.015 0 1.226l-1.879.695a.65.65 0 0 0-.386.386l-.695 1.879a.654.654 0 0 1-1.226 0l-.696-1.879a.65.65 0 0 0-.386-.386zM77.742 70.614a.37.37 0 0 1 0-.695l1.064-.394a.37.37 0 0 0 .22-.219l.393-1.064a.37.37 0 0 1 .695 0l.394 1.064a.37.37 0 0 0 .219.22l1.064.393a.37.37 0 0 1 0 .695l-1.064.394a.37.37 0 0 0-.219.219l-.394 1.064a.37.37 0 0 1-.695 0l-.394-1.064a.37.37 0 0 0-.219-.219zM67.742 84.387l-.828.773a.52.52 0 0 0 0 .774l.828.773c.23.214.6.214.829 0l.828-.773a.52.52 0 0 0 0-.774l-.828-.773a.615.615 0 0 0-.829 0M104.571 74.387l.828.773a.52.52 0 0 1 0 .774l-.828.773a.616.616 0 0 1-.829 0l-.828-.773a.52.52 0 0 1 0-.774l.828-.773a.616.616 0 0 1 .829 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "error_svg__a",
    x1: 101.53,
    x2: 74.461,
    y1: 99.121,
    y2: 67.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F58EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24A5FF"
  })))));
};
export default SvgError;